// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "b7d2589e37ca2ddd1acc" + ".chunk.js";
};